import { render, staticRenderFns } from "./DisplayJsonObjectToListComponent.vue?vue&type=template&id=39bfae00&"
import script from "./DisplayJsonObjectToListComponent.vue?vue&type=script&lang=js&"
export * from "./DisplayJsonObjectToListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports